// A tiny global toast/event bus with safe fallbacks.
// Usage: import { toast, onToast, offToast } from '../utils/toastBus';

const hasWindow = typeof window !== 'undefined' && typeof window.addEventListener === 'function';
const EVT = 'app_toast_event';

export function toast({ type = 'info', message = '', duration = 4000 } = {}) {
  const payload = { id: `${Date.now()}-${Math.random().toString(36).slice(2)}`, type, message, duration };
  if (hasWindow && typeof CustomEvent === 'function') {
    window.dispatchEvent(new CustomEvent(EVT, { detail: payload }));
  } else {
    // Fallback: console log when no DOM
    const label = type.toUpperCase();
    // eslint-disable-next-line no-console
    console.log(`[toast:${label}] ${message}`);
  }
}

export function onToast(handler) {
  if (!hasWindow) return () => {};
  const listener = (e) => {
    try { handler(e.detail); } catch {}
  };
  window.addEventListener(EVT, listener);
  return () => window.removeEventListener(EVT, listener);
}

export function offToast(handler) {
  if (!hasWindow) return;
  window.removeEventListener(EVT, handler);
}
